import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "placeholder-item__info"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("ul", {
    class: _normalizeClass('placeholder-list placeholder-list--' + $props.type)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.placeholderData, (item, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: index,
        class: "placeholder-item"
      }, [
        ($props.type !== 'event-cards')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "placeholder-item__avatar",
              style: _normalizeStyle({ '--avatar-size': item.avatarSize })
            }, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "placeholder-item__avatar-circle" }, null, -1)
            ]))], 4))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "placeholder-item__content",
          style: _normalizeStyle({ '--last-line-width': item.width })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.amount, (idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: idx,
              class: "placeholder-item__content-line"
            }))
          }), 128))
        ], 4),
        ($props.type === 'messages')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ], 2))
}